import styled from 'styled-components/macro';

export const Fade = styled.div`
  background-color: #000000;
  opacity: 0.4;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 500;
`;

export const ModalWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  z-index: 600;
  background: ${(props) => props.theme.colors.modal};
  background-color: ${(props) => props.theme.colors.white};
  padding: 16px;
  position: fixed;
  left: 0;
  bottom: 0;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  box-shadow: 0 0 10px 6px rgba(15, 23, 40, 0.04),
    0 4px 8px 0 rgba(15, 23, 40, 0.12), 0 2px 4px 0 rgba(15, 23, 40, 0.04);
  display: flex;
  flex-direction: column;
`;

export const ButtonsWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const PhoneRow = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const Body = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  height: 250px;
`;

export const CloseText = styled.div`
  box-sizing: border-box;
  width: fit-content;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
  color: ${(props) => props.theme.colors.primary[600]};
  position: absolute;
  top: 16px;
  left: 16px;
`;
